export class SpeachEvent{
    private name:SpeachEventName;
    private data:any;
    constructor(name:SpeachEventName,data?:any) {
        this.name=name;
        this.data=data;
    }
}

export class SpeachEventAvatarDuration{
    private weetID:string;
    private seconds:number;
    constructor(weetID:string, seconds:number) {
        this.weetID=weetID;
        this.seconds=seconds;
    }
}
export class SpeachEventVideoDuration {
  private weetID: string;
  private seconds: number;
  constructor(weetID: string, seconds: number) {
    this.weetID = weetID;
    this.seconds = seconds;
  }
}

export const NB_IMAGE_PRO_CREDIT = 3;

export class SpeachEventImageProMode {
  private weetID: string;
  private credits: number;
  constructor(weetID: string, credits: number) {
    this.weetID = weetID;
    this.credits = credits;
  }
}

export class SpeachEventTtsUsage {
    private weetID: string;
    private credits: number;
    constructor(weetID: string, credits: number) {
        this.weetID = weetID;
        this.credits = credits;
    }
}

export class SpeachModification{
    private weetID:string;
    private modified:boolean;
    private duration:number;

    constructor(weetID:string, modified:boolean,duration:number) {
        this.weetID=weetID;
        this.modified=modified;
        this.duration=duration;
    }
}


export enum SpeachEventName {
  SEND_WEET_ID = "SEND_WEET_ID",
  WEET_PLAYING = "WEET_PLAYING",
  WEET_END = "WEET_END",
  WEET_PAUSING = "WEET_PAUSING",
  SILENTLY_SEND_WEET_ID = "SILENTLY_SEND_WEET_ID",
  EDIT_WEET = "EDIT_WEET",
  AIAVATAR_DURATION = "AIAVATAR_DURATION",
  VIDEO_GENERATION_DURATION = "VIDEO_GENERATION_DURATION",
  IMAGE_PRO_MODE = "IMAGE_PRO_MODE",
  TTS_USAGE = "TTS_USAGE",
  LOGGED_OUT = "LOGGED_OUT",
  GENERATION_PROGRESS = "GENERATION_PROGRESS",
}
